/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */
(() => {
    class VideoPlayerToggle {
        constructor(container) {
            this.container = container;
            if (!this.container) return;
            
            this.observer = new MutationObserver(() => this.init());
            this.observer.observe(this.container, { childList: true, subtree: true });
            
            this.init();
        }
        
        init() {
            const videoWrappers = [...this.container.querySelectorAll('video-component')];
            
            if (!videoWrappers.length) return;
            
            videoWrappers.forEach(wrapper => {
                if (wrapper.dataset.videoBound) return;
                
                const video = wrapper.querySelector('video');
                const toggleBtn = wrapper.querySelector('.video-toggle');
                if (!video || !toggleBtn) return;
                
                wrapper.dataset.videoBound = 'true';
                
                video.muted = true;
                
                toggleBtn.addEventListener('click', () => {
                    if (video.paused) {
                        video.play().catch(() => {});
                    } else {
                        video.pause();
                    }
                });
                
                video.addEventListener('play', () => this.updateBtn(toggleBtn, true));
                video.addEventListener('pause', () => this.updateBtn(toggleBtn, false));
                video.addEventListener('ended', () => this.updateBtn(toggleBtn, false));
                
                video.play().catch(() => this.updateBtn(toggleBtn, false));
            });
        }
        
        updateBtn(btn, isPlaying) {
            const iconPlay = btn.dataset.iconPlay;
            const iconPause = btn.dataset.iconPause;
            btn.innerHTML = isPlaying ? iconPause : iconPlay;
        }
    }
    
    const selectors = [
        '[id^="section-id-"].video-section',
        '[id^="section-id-"] .video-section',
        '.cms-mansory-block .video-section',
        'deferred-media.product-media--video',
        'scrolling-image-list .video-section'
    ];
    
    document.querySelectorAll(selectors.join(', ')).forEach(el => {
        if (!el.dataset.videoInitialized) {
            new VideoPlayerToggle(el);
            el.dataset.videoInitialized = 'true';
        }
    });
})();